import { parseISO } from "date-fns";

export const toDate = date => {
  return parseISO(date, new Date());
};
